export default "__VITE_ASSET__DgCh30sQ__"